import { ContentBox, useBreadcrumbTitle } from "@msuite/ui/app-shell";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { useWarehouseZone } from "@/hooks/use-warehouse-zone";
import { WarehouseZoneGeneral } from "./warehouse-zone-general";
import { WarehouseZoneLocations } from "./warehouse-zone-locations";

export function WarehouseZone() {
	/** Hooks */
	const warehouseZoneId = useParams().warehouseZoneId as string;
	const { t } = useTranslation();
	const { warehouseZone } = useWarehouseZone(warehouseZoneId);
	useBreadcrumbTitle(warehouseZoneId, warehouseZone?.name);

	/** Render */
	return (
		<ContentBox>
			<Tabs
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <WarehouseZoneGeneral warehouseZoneId={warehouseZoneId} />,
								cyId: "general-tab",
								errors: [],
							},
						],
					},
					{
						name: "details",
						panels: [
							{
								label: t("stock.warehouse_locations"),
								panel: () => <WarehouseZoneLocations warehouseZoneId={warehouseZoneId} />,
								cyId: "warehouse-locations-tab",
								errors: [],
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
